<template>
  <div class="tab-content profile-content">
    <template v-if="isLoggedIn">
      <div class="user-header-card">
        <div class="avatar">
          <i class="el-icon-user-solid"></i>
        </div>
        <div class="user-info">
          <div class="username">{{ t('userTitle') }}</div>
          <div class="balance">{{ t('snCodeLabel') }}<span class="sn-code-text">{{ currentSn }}</span></div>
        </div>
      </div>

      <div class="asset-card">
        <div class="section-title">
          <span>{{ t('assetTitle') }}</span>
          <span class="plan-badge">{{ t('planBadge') }}</span>
        </div>
        
        <div class="data-progress-box">
          <div class="progress-bar-bg">
            <div class="progress-bar-fill" :style="{ width: usagePercent + '%' }"></div>
          </div>
        </div>

        <div class="data-stats-grid">
          <div class="stat-item">
            <span class="stat-label">{{ t('totalData') }}</span>
            <span class="stat-value">{{ dataPlan.total }} <small>GB</small></span>
          </div>
          <div class="stat-item">
            <span class="stat-label">{{ t('usedData') }}</span>
            <span class="stat-value used-color">{{ dataPlan.used }} <small>GB</small></span>
          </div>
          <div class="stat-item">
            <span class="stat-label">{{ t('remainingData') }}</span>
            <span class="stat-value remaining-color">{{ dataPlan.remaining }} <small>GB</small></span>
          </div>
        </div>
      </div>

      <div class="order-section">
        <div class="section-title">{{ t('orderHistoryTitle') }}</div>
        <div class="order-list">
          <div v-for="order in orderHistory" :key="order.id" class="order-item">
            <div class="order-main">
              <span class="order-type">{{ order.type }}</span>
              <span class="order-amount">+￥{{ order.amount }}</span>
            </div>
            <div class="order-sub">
              <span class="order-date">{{ order.date }}</span>
              <span class="order-status">{{ order.status }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="contact-info-card">
        <div class="section-title">{{ t('contactInfo.title') }}</div>
        <div class="contact-list">
          <div class="contact-item">
            <span class="contact-icon">📧</span>
            <div class="contact-detail">
              <span class="contact-label">{{ t('contactInfo.email') }}</span>
              <span class="contact-value">service@starlighting.hk</span>
            </div>
          </div>

          <div class="contact-item">
            <span class="contact-icon">📍</span>
            <div class="contact-detail">
              <span class="contact-label">{{ t('contactInfo.address') }}</span>
              <span class="contact-value address-text">
                RM02, UNIT A 21/F, TOWER B, BILLION CENTRE, NO.1 WANG KWONG ROAD, KOWLOON BAY, KOWLOON, HONG KONG
              </span>
            </div>
          </div>

          <div class="contact-item">
            <span class="contact-icon">📞</span>
            <div class="contact-detail">
              <span class="contact-label">{{ t('contactInfo.tel') }}</span>
              <span class="contact-value">+852 5809 0414</span>
            </div>
          </div>

          <div class="contact-item">
            <span class="contact-icon">💬</span>
            <div class="contact-detail">
              <span class="contact-label">{{ t('contactInfo.whatsapp') }}</span>
              <span class="contact-value">+852 5613 6142</span>
            </div>
          </div>
        </div>
      </div>

      <div class="logout-card" @click="handleLogout">
        <i class="el-icon-switch-button"></i>
        <span>{{ t('logoutBtn') }}</span>
      </div>
    </template>

    <template v-else>
      <Login :lang="lang" @login-success="onLoginSuccess" />
    </template>
  </div>
</template>

<script>
import Login from './Login.vue'
import i18nData from '@/i18n/locales.js'

export default {
  name: 'ProfileTab',
  components: { Login },
  props: {
    lang: { type: String, default: 'zh' },
    isLoggedIn: { type: Boolean, default: false },
    currentSn: { type: String, default: '' },
    dataPlan: {
      type: Object,
      default: () => ({ total: 100, used: 0, remaining: 100 })
    },
    orderHistory: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      i18n: i18nData
    }
  },
  computed: {
    usagePercent() {
      if (!this.dataPlan.total) return 0
      return Math.min(100, Math.round((this.dataPlan.used / this.dataPlan.total) * 100))
    }
  },
  methods: {
    t(key) {
      const keys = key.split('.')
      let val = this.i18n[this.lang]
      for (const k of keys) {
        if (val && val[k] !== undefined) {
          val = val[k]
        } else {
          return key
        }
      }
      return val
    },
    onLoginSuccess(sn) {
      this.$emit('login-success', sn)
    },
    handleLogout() {
      this.$emit('logout')
    }
  }
}
</script>

<style scoped>
@import '../assets/styles/profile.css';
</style>